import {
  fromJS
} from 'immutable';

export default fromJS({})



// WEBPACK FOOTER //
// ./src/reducers/initialState.js